// extracted by mini-css-extract-plugin
export default {"link":"FQ-z","disabled":"GQ-z"};